import React from 'react';

export function VerifyBadgeIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 20 21"
      {...props}
    >
      <path d="M10 1.468L2.5 4.8v5c0 4.625 3.2 8.95 7.5 10 4.3-1.05 7.5-5.375 7.5-10v-5L10 1.468zM8.333 14.8L5 11.467l1.175-1.175 2.158 2.15 5.492-5.491L15 8.134l-6.667 6.667z" />
    </svg>
  );
}
